import { getUserPreviewUrl } from "@repo/utils/appUrls.ts";
export function usePreviewUrl(loader, imageName, galleryName, groupId) {
    if (loader === "cloud-function") {
        return getUserPreviewUrl(imageName, galleryName, groupId);
    }
    return `/api/public/users/gallery/image/${imageName}?gallery=${encodeURIComponent(galleryName)}&gId=${groupId}`;
}
